<template>
  <b-modal
    id="SaveOrganizationModal"
    class="modal"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    @hidden="doCancel"
  >
    <template
      slot="modal-header"
      slot-scope="{ close }"
    >
      <h5>{{ modalTitle }}</h5>
      <button
        class="btn btn--close"
        @click="close()"
      >
        <font-awesome-icon
          :icon="['fal', 'times']"
          class="icon alt"
        />
      </button>
    </template>


    <form-component>
      <form
        novalidate="novalidate"
        @submit.prevent
      >
        <b-card no-body>
          <b-tabs card>
            <b-tab
              title="Contact Info"
              active
            >
              <b-card-text>
                <input-text
                  id="name"
                  v-model="name"
                  v-validate="'required'"
                  name="name"
                  data-vv-name="name"
                  data-vv-as="organizaion name"
                  label="Organization Name"
                  type="text"
                  required
                  :disabled="!$store.getters.isKgbAdminUser"
                  :error="errors.first('name')"
                />

                <input-text
                  id="email_address"
                  v-model="email_address"
                  v-validate="'required|email'"
                  name="email_address"
                  data-vv-name="email_address"
                  data-vv-as="email address"
                  label="Email Address"
                  type="email"
                  required
                  :error="errors.first('email_address')"
                />

                <MazPhoneNumberInput
                  :class="{'show-invalid': attemptedSave && !validPhoneNumber}"
                  :default-country-code="phone_country_code"
                  :default-phone-number="initial_phone"
                  :success="false"
                  @update="updatePhoneNumber($event)"
                />
                <p
                  v-show="attemptedSave && !validPhoneNumber"
                  class="form__error"
                >
                  The Phone Number field is required and must be valid.
                </p>
                <input-select
                  id="allowed_to_remove_files"
                  v-model="allowed_to_remove_files"
                  v-validate="'required'"
                  name="allowed_to_remove_files"
                  data-vv-name="allowed_to_remove_files"
                  data-vv-as="Allow Users To Remove Files"
                  label="Allow Users To Remove Files"
                  :required="true"
                  :error="errors.first('allowed_to_remove_files')"
                  :options="statusOptions"
                />
                <input-select
                  v-if="$store.getters.isKgbAdminUser"
                  id="kgb_admin_allowed_download_of_files"
                  v-model="kgb_admin_allowed_download_of_files"
                  v-validate="'required'"
                  name="kgb_admin_allowed_download_of_files"
                  data-vv-name="kgb_admin_allowed_download_of_files"
                  data-vv-as="Allow download by users outside organization"
                  label="Allow download by users outside organization"
                  :required="true"
                  :error="errors.first('kgb_admin_allowed_download_of_files')"
                  :options="statusOptions"
                />
                <input-select
                  v-if="$store.getters.isKgbAdminUser"
                  id="is_allowed_demo_access"
                  v-model="is_allowed_demo_access"
                  v-validate="'required'"
                  name="is_allowed_demo_access"
                  data-vv-name="is_allowed_demo_access"
                  data-vv-as="Allow Users To Access Demo Site"
                  label="Allow Users To Access Demo Site"
                  :required="true"
                  :error="errors.first('is_allowed_demo_access')"
                  :options="statusOptions"
                />
                <input-select
                  id="is_allowed_data_encryption"
                  v-model="is_allowed_data_encryption"
                  v-validate="'required'"
                  name="is_allowed_data_encryption"
                  data-vv-name="is_allowed_data_encryption"
                  data-vv-as="Use Organization PGP Keys to Encrypt Data"
                  label="Use Organization PGP Keys to Encrypt Data"
                  :required="true"
                  :error="errors.first('is_allowed_data_encryption')"
                  :options="statusOptions"
                />
              </b-card-text>
            </b-tab>
            <b-tab
              v-if="id > 0 && is_allowed_data_encryption === 'true'"
              title="Encryption"
            >
              <h6>Current Public Keys</h6>
              <responsive-table>
                <thead class="inline-header">
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="encryptionKey of encryptionKeys"
                    :key="encryptionKey.id"
                  >
                    <td>{{ encryptionKey.name }} </td>
                    <td>{{ encryptionKey.email }}</td>
                    <td class="actions">
                      <button
                        v-b-tooltip.hover
                        class="red-hover"
                        title="Delete"
                        type="button"
                        @click="deleteEncryptionKey(encryptionKey.id)"
                      >
                        <font-awesome-icon
                          :icon="['fas', 'trash']"
                          class="icon alt"
                        />
                      </button>
                    </td>
                  </tr>
                </tbody>
              </responsive-table>

              <button
                title="Add"
                type="button"
                class="btn btn--primary"
                @click="addPublicKey()"
              >
                Add New Key
              </button>
            </b-tab>
            <b-tab
              v-if="$store.getters.currentUser.allowed_to_access_management"
              title="Management"
            >
              <input-select
                v-if="dartVersionOptions && dartVersionOptions.length > 0"
                id="dart_software_version"
                v-model="dart_software_version"
                v-validate="'required'"
                name="dart_software_version"
                data-vv-name="dart_software_version"
                data-vv-as="Latest Approved DART Version"
                label="Latest Approved DART Version"
                :required="true"
                :error="errors.first('dart_software_version')"
                :options="dartVersionOptions"
                key-field="name"
                display-field="name"
              />
            </b-tab>
          </b-tabs>
        </b-card>
      </form>
    </form-component>

    <template
      slot="modal-footer"
    >
      <button
        class="btn"
        type="button"
        @click="doCancel()"
      >
        Cancel
      </button>
      <button
        class="btn btn--primary"
        type="button"
        :disabled="saving"
        @click="save()"
      >
        <font-awesome-icon
          v-if="saving"
          :spin="true"
          :icon="['fas', 'spinner']"
          class="icon alt"
        />
        <span v-else>Save</span>
      </button>
    </template>
  </b-modal>
</template>

<script>
/* eslint-disable vue/require-default-prop */
import FormComponent from '@/components/FormComponent.vue';
import ResponsiveTable from '@/components/ResponsiveTable.vue';
import InputSelect from '@/components/inputs/InputSelect.vue';
import InputText from '@/components/inputs/InputText.vue';

export default {
  name: 'OrganizationModal',
  components: {
    FormComponent,
    InputText,
    InputSelect,
    ResponsiveTable,
  },
  props: {
    doCancel: {
      type: Function,
    },
    organizations: {
      type: Array,
    },
    dartVersionOptions: {
      type: Array,
    },
    defaultSoftwareVersion: {
      type: String,
    },
    doSave: {
      type: Function,
    },
    doShowAddEncryption: {
      type: Function,
    },
    doRemoveEncryption: {
      type: Function,
    },
  },
  data: () => ({
    id: 0,
    name: '',
    phone_number: '',
    initial_phone: '',
    attemptedSave: false,
    phone_number_e164: '',
    phone_country_code: '',
    validPhoneNumber: false,
    email_address: '',
    allowed_to_remove_files: 'false',
    kgb_admin_allowed_download_of_files: 'true',
    is_allowed_demo_access: 'false',
    is_allowed_data_encryption: 'false',
    dart_software_version: '',
    statusOptions: [
      { id: 'true', display_label: 'Enabled' },
      { id: 'false', display_label: 'Disabled' },
    ],
    encryptionKeys: [],
    saving: false,
  }),
  computed: {
    modalTitle() {
      return this.id > 0 ? 'Edit Organization' : 'New Organization';
    },
  },
  methods: {
    save() {
      this.attemptedSave = true;

      this.$validator.validateAll().then((result) => {
        if (result && this.validPhoneNumber) {
          this.errors.clear();
          this.saving = true;
          this.doSave(
            this.id,
            this.name,
            this.email_address,
            this.phone_number,
            this.phone_country_code,
            this.phone_number_e164,
            this.allowed_to_remove_files === 'true',
            this.kgb_admin_allowed_download_of_files === 'true',
            this.is_allowed_demo_access === 'true',
            this.is_allowed_data_encryption === 'true',
            this.dart_software_version || this.defaultSoftwareVersion,
          );
        }
      });
    },
    updatePhoneNumber(phoneEvent) {
      this.validPhoneNumber = phoneEvent.isValid;
      this.phone_number = phoneEvent.formatNational;
      this.phone_country_code = phoneEvent.countryCode;
      this.phone_number_e164 = phoneEvent.e164;
    },
    setModal(model) {
      this.attemptedSave = false;
      this.encryptionKeys = [];
      this.saving = false;
      this.id = model.id || 0;
      this.name = model.name || '';
      this.initial_phone = model.phone_number || '';
      this.phone_number = model.phone_number || '';
      this.phone_country_code = model.phone_country_code || '';
      this.phone_number_e164 = model.phone_number_e164 || '';
      this.validPhoneNumber = model.phone_number_e164 && model.phone_number_e164.length > 0;
      this.email_address = model.email_address || '';
      this.allowed_to_remove_files = model.allowed_to_remove_files ? 'true' : 'false';
      this.kgb_admin_allowed_download_of_files = model.kgb_admin_allowed_download_of_files ? 'true' : 'false';
      this.is_allowed_demo_access = model.is_allowed_demo_access ? 'true' : 'false';
      this.is_allowed_data_encryption = model.is_allowed_data_encryption ? 'true' : 'false';
      this.dart_software_version = model.dart_software_version || this.defaultSoftwareVersion;
    },
    setKeys(keys) {
      this.encryptionKeys = keys;
    },
    deleteEncryptionKey(key) {
      this.doRemoveEncryption(this.id, key);
    },
    addPublicKey() {
      this.doShowAddEncryption({ id: this.id, name: this.name });
    },
  },
};
</script>

<style scoped lang="scss">

</style>
